export default {"src":"/_next/static/media/dislike.0cfe2ef8.svg","height":11,"width":13,"blurWidth":0,"blurHeight":0};